export default "__VITE_ASSET__CTPoN_h0__"